import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  // Elements flow uses `payment_intent`; legacy Checkout uses `session_id`.
  const sessionId = params.get("payment_intent") || params.get("session_id");
  const nextUrl = params.get("next");
  const [status, setStatus] = useState("checking");
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) { setStatus("missing"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          refresh();
          // Auto-redirect to next URL (e.g. back to listing edit for featured flow)
          if (nextUrl) {
            setTimeout(() => nav(nextUrl, { replace: true }), 1500);
          }
          return;
        }
        if (data.status === "expired" || data.status === "canceled") { setStatus("expired"); return; }
        if (attempts < 15) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch {
        if (attempts < 5) setTimeout(poll, 2000);
        else setStatus("error");
      }
    };
    poll();
  }, [sessionId, refresh, nextUrl, nav]);

  return (
    <div className="max-w-2xl mx-auto px-4 md:px-8 py-24 text-center" data-testid="payment-success-page">
      {status === "checking" && (<>
        <i className="fas fa-circle-notch fa-spin text-5xl text-[#FFBE00] mb-6"></i>
        <h1 className="font-heading font-black text-3xl">Verifica pagamento…</h1>
        <p className="text-zinc-400 mt-3">Un attimo di pazienza.</p>
      </>)}
      {status === "paid" && (<>
        <i className="fas fa-circle-check text-5xl text-[#22C55E] mb-6"></i>
        <h1 className="font-heading font-black text-4xl">Pagamento <span className="text-[#FFBE00]">completato!</span></h1>
        <p className="text-zinc-400 mt-3">Il tuo abbonamento è attivo. Il tuo annuncio è ora pubblicato.</p>
        <Link to="/dashboard" className="inline-block mt-8 px-6 py-3 rounded-md bg-[#E619A8] text-white font-bold uppercase tracking-wider text-sm" data-testid="success-dashboard-btn">Vai alla dashboard</Link>
      </>)}
      {(status === "expired" || status === "error" || status === "missing") && (<>
        <i className="fas fa-circle-xmark text-5xl text-red-500 mb-6"></i>
        <h1 className="font-heading font-black text-3xl">Pagamento non completato</h1>
        <p className="text-zinc-400 mt-3">Riprova dalla pagina prezzi.</p>
        <Link to="/prezzi" className="inline-block mt-8 px-6 py-3 rounded-md bg-[#FFBE00] text-black font-bold uppercase tracking-wider text-sm">Torna ai prezzi</Link>
      </>)}
      {status === "pending" && (<>
        <i className="fas fa-hourglass-half text-5xl text-[#FFBE00] mb-6"></i>
        <h1 className="font-heading font-black text-3xl">In elaborazione</h1>
        <p className="text-zinc-400 mt-3">Il pagamento risulta in elaborazione. Riceverai conferma a breve.</p>
        <Link to="/dashboard" className="inline-block mt-8 px-6 py-3 rounded-md border border-zinc-700 text-sm uppercase">Vai alla dashboard</Link>
      </>)}
    </div>
  );
}
